import { ReactNode, useEffect, useRef } from 'react';
import Ably from 'ably';
import { AblyProvider } from 'ably/react';
import { ABLY_AUTH_URL } from 'common/config/app';

interface AblyContextProviderProps {
  children: ReactNode;
}

const AblyContextProvider = ({ children }: AblyContextProviderProps) => {
  const clientRef = useRef<Ably.Realtime | null>(null);

  if (!clientRef.current) {
    clientRef.current = new Ably.Realtime({
      authCallback: async (_data, callback) => {
        try {
          const accessToken = localStorage.getItem('access') ?? '';
          const response = await fetch(ABLY_AUTH_URL, {
            method: 'GET',
            headers: { Authorization: `Bearer ${accessToken}` },
          });
          if (!response.ok) {
            callback(`Auth failed: ${response.status}`, null);
            return;
          }
          const { token } = await response.json();
          callback(null, token);
        } catch (err) {
          callback(String(err), null);
        }
      },
    });
  }

  useEffect(() => () => {
    clientRef.current?.close();
    clientRef.current = null;
  }, []);

  return <AblyProvider client={clientRef.current}>{children}</AblyProvider>;
};

export default AblyContextProvider;
